export function formatCode(code) {
  let newCode
  newCode = code.replace(/^import(.*)/gm, '');
  newCode = newCode.replace('export default ', '')
  // Remove multiline comments
  newCode = newCode.replace(/\/\*([\s\S]*?)\*\//g, '');
  // fix empty lines
  newCode = newCode.replace(/^[\r\n]+|[\r\n]+$/g, '');
  return newCode
}

export function prefixCode(componentName, code) {
  // prefix with usage instructions
  const prefix = `/* Import React & Component */
import React from 'react'
import ${componentName} from 'path/to/${componentName}'

`
  return prefix + code;
}



// WEBPACK FOOTER //
// ./src/components/Code/utils/index.js